const isDev = process.env.NODE_ENV === "development";

export const utils = {
  isDev
};
